import {activateOPButton} from '@1password/save-button';

if (document.querySelectorAll('[data-onepassword-type]').length) {
    activateOPButton();
}
